import { useForm } from "react-hook-form";
import styles from "./Login.module.css";
import { Input } from "../../../../common/Input";
import { PayWithButton } from "../../../../common/PayWithButton";
import { ButtonFooter } from "../../../../common/ButtonFooter";
import { useState } from "react";

export const Login = ({
  onPay,
  isLoading,
  emailError,
  setEmailError,
}: {
  onPay?: any;
  isLoading?: boolean;
  emailError?: string;
  setEmailError?: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const { register, handleSubmit, getValues } = useForm();
  const values = getValues();

  const [value, setValue] = useState(values);

  const handleInputChange = (e: any) => {
    setValue({
      ...value,
      [e.target.inputId]: e.target.value,
    });
  };

  return (
    <div className={styles.container}>
      <form onSubmit={(e) => { e.preventDefault(); handleSubmit(onPay)(e); }} autoComplete="off">
        <div className={styles.form}>
          <Input
            register={register}
            inputId="username"
            type="text"
            placeholder="Email"
            required={true}
            labelfocus="Email"
            onChange={handleInputChange}
            errorText={emailError}
            setErrorText={setEmailError}
          />
          <Input
            register={register}
            inputId="password"
            type="password"
            placeholder="Password"
            required={true}
            labelfocus="Password"
            onChange={handleInputChange}
          />
        </div>

        <ButtonFooter showNote>
          <PayWithButton
            isDisabled={!values?.username?.length || !values?.password?.length}
            isLoading={isLoading}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
